import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'page-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.scss'],
})
export class ScheduleComponent implements OnInit {
  public title = 'Agendar';

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.goToUrl('secretarias-new/agendar/especialistas/exame');
  }

  goToUrl(page: string) {
    this.router.navigate([page]);
  }
}
